<template>
  <div>
    <form id="payment-form" action="/charge" method="post">
      <div class="stripe-form">
        <div ref="card-element" class="card-element">
          <!-- Stripe Element will be inserted here. -->
        </div>

        <!-- Used to display Element errors. -->
        <div id="card-errors" role="alert"></div>
      </div>

      <div class="is-centered">
        <button class="large-button">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { stripe, stripeCard } from '@/services/utils/stripe'

export default {
  name: 'StripeForm',
  data() {
    return {}
  },
  mounted: function() {
    // within mounted hooks because we mount stripeCard element after DOM has been loaded
    stripeCard.mount(this.$refs['card-element'])

    stripeCard.addEventListener('change', ({ error }) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Create a token or display an error when the form is submitted.
    const form = document.getElementById('payment-form')
    form.addEventListener('submit', async event => {
      event.preventDefault()

      const { token, error } = await stripe.createToken(stripeCard)

      if (error) {
        // Inform the customer that there was an error.
        const errorElement = document.getElementById('card-errors')
        errorElement.textContent = error.message
      } else {
        // Send the token to CF server.
        this.stripeTokenHandler(token)
      }
    })
  },
  methods: {
    stripeTokenHandler(stripeToken) {
      // NRS 8.29.19 - Once this form gets a stripe token back from the stripe API, this tells the parent component that it got a token back
      // I think in all cases, we can assume that we want to add this new card to the user as well, so eventually I can move that logic to this
      // child component
      this.$emit('stripe-token-returned', stripeToken)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';

.is-centered {
  display: flex;
  justify-content: center;
}

.card-element {
  border-bottom: 1px solid $base-gray;
  padding: 0.5rem 0;
}

#card-errors {
  padding-top: 0.5rem;
  color: #fa755a;
}
</style>
